import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProcessDetail } from '../../../models/process-models';
import { ReopenProcess } from '../../../models/process-models/reopen-process.model';
import { NamedEntity } from '../../../models/named-entity.model';
import { getWithoutTime, parseUtcDate } from '../../../helpers/date-helper';
import { ProcessService } from '../../../services/process.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reopen-process-modal',
  templateUrl: './reopen-process-modal.component.html',
  styleUrls: ['./reopen-process-modal.component.scss']
})
export class ReopenProcessModalComponent implements OnInit, OnDestroy {

  processDetail: ProcessDetail;
  reopenModel: ReopenProcess;
  endDate: Date;
  appraiseesToSelect: Array<NamedEntity>;
  selectedAppraisees: Array<NamedEntity> = [];
  isAllSelected: boolean;
  selected = null;
  isReopened: boolean;
  currentDate = new Date();
  isSpinnerEnable: boolean;
  showModal = true;
  private subscription: Subscription = new Subscription();

  constructor(public modalRef: BsModalRef, 
    private processService: ProcessService,
    private bsModalService: BsModalService,
    private subModalRef: BsModalRef) { }

  ngOnInit() {
    this.reopenModel = {
      processDurationId: this.processDetail.processDurations[0].id,
    };
    this.endDate = new Date();
    this.selectAllToggleChanged(false);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setSpinnerEnabled(isEnabled: boolean) {
    this.isSpinnerEnable = isEnabled;
}

  onAppraiseeSelected(appraiseeId: number) {
    let item = this.appraiseesToSelect.find(c => c.id == appraiseeId);
    this.selectedAppraisees.push(item);
    this.selected = null;
    this.setAppraiseesToSelect();
  }

  removeSelected(a :NamedEntity) {
    let index = this.selectedAppraisees.indexOf(a);
    this.selectedAppraisees.splice(index, 1);
    this.setAppraiseesToSelect();
  }
  
  setAppraiseesToSelect() {
    this.appraiseesToSelect = this.getOriginalAppraisees().filter(c => !this.selectedAppraisees.some(a => c.id == a.id));
  }

  selectAllToggleChanged(isAllSelected: boolean) {
    this.isAllSelected = isAllSelected;
    this.selectedAppraisees = isAllSelected ? this.getOriginalAppraisees() : [];
    this.setAppraiseesToSelect();
  }

  onReopenClicked(modalTemplate: TemplateRef<any>) {
    this.endDate = parseUtcDate(this.endDate);
    if (getWithoutTime(this.endDate) < getWithoutTime(new Date()) || this.selectedAppraisees.length == 0) return;
    this.showModal = false;
    this.subModalRef = this.bsModalService.show(modalTemplate);
    this.bsModalService.onHidden.subscribe(() => {
      this.showModal = true;
    });
  }
  onNotificationSelect(isNotificationsNeeded:boolean){
    this.reopenModel.appraiseeIds = this.selectedAppraisees.map(c => c.id);
    this.reopenModel.endDate = this.endDate.toISOString();
    this.reopenModel.isSendEmail = isNotificationsNeeded;
    this.setSpinnerEnabled(true);
    this.subscription.add(
      this.processService.reopen(this.reopenModel).subscribe(x => {
      this.setSpinnerEnabled(false);    
      this.isReopened = true;
      this.subModalRef.hide();
      this.modalRef.hide();
      })
    )
  }

  private getOriginalAppraisees() {
    return this.processDetail.appraiseeProcessDetails.map(c => ({id: c.processDurationAppraiseeId, name: c.appraisee ? c.appraisee.name : 'Empty name'} as NamedEntity));
  }

}
